import { __decorate, __metadata } from "tslib";
import { LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString, IsUrl } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
export class PatchFaviconDto {
    constructor() {
        this.appleMobileWebWappTitle = '';
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], PatchFaviconDto.prototype, "themeColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 100, { always: true }),
    __metadata("design:type", String)
], PatchFaviconDto.prototype, "applicationName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchFaviconDto.prototype, "appleMobileWebWappTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmpty({ always: true }),
    IsUrl({ require_protocol: true, require_host: true, require_valid_protocol: true }, { always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchFaviconDto.prototype, "cloudinaryFaviconFolderUrl", void 0);
//# sourceMappingURL=PatchFaviconDto.js.map